// extracted by mini-css-extract-plugin
export default {"wrapper":"Filters_wrapper__dF81a","btn":"Filters_btn__f3tGW","clearWrapper":"Filters_clearWrapper__OKPK4","clear":"Filters_clear__0nftQ","clearBtn":"Filters_clearBtn__uobCx"};